import { get } from 'lodash';

import Model from 'models';
import Settings from 'utils/Settings';
import Shipping from 'utils/Shipping';

const Cart = class extends Model {
  get subtotal() {
    return get(this._data, 'total_price', 0);
  }

  get subtotalWithCurrency() {
    return get(this._data, 'total_price_with_currency', '');
  }

  get subtotalWithoutCurrency() {
    return get(this._data, 'total_price_without_currency');
  }

  get subtotalWithoutTrailingZeros() {
    return get(this._data, 'total_price_without_trailing_zeros');
  }

  get itemCount() {
    return get(this._data, 'item_count');
  }

  get giftMessage() {
    return get(this.attributes, 'gift_message');
  }

  get useLogoFreePackaging() {
    // attributes are set as strings due to being query params. This is easy way to convert
    return get(this.attributes, 'logo_free') === 'true';
  }

  get attributes() {
    return get(this._data, 'attributes');
  }

  get itemIds() {
    return get(this._data, 'items');
  }

  /* eslint-disable class-methods-use-this */
  get freeShippingMinimumValue() {
    return Settings.freeShippingThreshold * 100;
  }
  /* eslint-disable */

  get hasFreeShipping() {
    return Shipping.cartValueExceedsFreeShippingThreshold(
      this.subtotal,
      this.freeShippingMinimumValue
    );
  }

  get valueRemainingForFreeShipping() {
    return Shipping.cartValueRemainingForFreeShipping(this.subtotal, this.freeShippingMinimumValue);
  }

  get percentageUntilFreeShipping() {
    return Shipping.cartPercentageUntilFreeShipping(this.subtotal, this.freeShippingMinimumValue);
  }
};

export default Cart;
